import React from 'react';
import { Boxes, BookmarkCheck, PackageCheck } from 'lucide-react';
import { StatCard } from '../ui/StatCard';
import { formatQuantity } from '../../utils/inventoryLabels';

/**
 * The three figures of a stock: what is left to promise, what is already
 * promised, and their sum.
 *
 * The server works all three out — nothing is subtracted here. Reserving moves
 * units from the first to the second without touching the total; picking takes
 * them out of both, because the unit leaves its location for the packing table.
 *
 * A negative "Disponible" is shown in red rather than floored at zero: more was
 * promised than there is, and that is exactly what has to be seen.
 *
 * @param {object} props
 * @param {{available: number, reserved: number, total: number}} props.totals -
 *   Over the whole filter, not over the visible page.
 */
export const StockTotals = ({ totals }) => {
  const available = Number(totals.available ?? 0);
  const isOverPromised = available < 0;

  return (
    <div data-testid="stock-totals" className="grid grid-cols-1 sm:grid-cols-3 gap-5">
      <StatCard
        title="Disponible"
        value={formatQuantity(available)}
        icon={PackageCheck}
        tone={isOverPromised ? 'danger' : 'success'}
        subtitle={isOverPromised ? 'Prometido más de lo que hay' : 'Queda para pedidos nuevos'}
      />
      <StatCard
        title="Reservado"
        value={formatQuantity(totals.reserved ?? 0)}
        icon={BookmarkCheck}
        tone="warning"
        subtitle="Prometido, aún sin pickear"
      />
      <StatCard
        title="Total"
        value={formatQuantity(totals.total ?? 0)}
        icon={Boxes}
        subtitle="Disponible + reservado"
      />
    </div>
  );
};
